import { render, staticRenderFns } from "./MergedCustomersList.vue?vue&type=template&id=5669114c&scoped=true"
import script from "./MergedCustomersList.vue?vue&type=script&lang=js"
export * from "./MergedCustomersList.vue?vue&type=script&lang=js"
import style0 from "./MergedCustomersList.vue?vue&type=style&index=0&id=5669114c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5669114c",
  null
  
)

export default component.exports